ready(() => {

    const promo = document.querySelector(".promo");
    if (promo) {
        let swiper = new Swiper(".promo__list", {
            wrapperClass: "promo__list-wrapper",
            slideClass: "promo__item",
            slidesPerView: 1,
            setWrapperSize: true,
            loop: false,
            navigation: {
                nextEl: ".promo .arrows__next",
                prevEl: ".promo .arrows__prev",
                disabledClass: "arrows__arrow_disabled",
            },
            breakpoints: {
                0: {
                    pagination: {
                        el: ".promo__dots .dots",
                        type: "fraction",
                    },
                },
                768: {
                    pagination: {
                        el: ".promo__dots .dots",
                        // dynamicBullets: false,
                        type: "fraction",
                    },
                },
            },
            autoplay: {
                delay: 3000
            },
        });

        function autoPlayStop() {
            swiper.autoplay.stop();
        }
        function autoPlayStart() {
            swiper.autoplay.start();
        }
        promo.addEventListener("mouseenter", autoPlayStop);
        promo.addEventListener("mouseleave", autoPlayStart);

        document.querySelector(".promo__scroll").addEventListener("click", (e) => {
            document.querySelector("main").scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });

    }

});
